const $ = jQuery.noConflict();

const loadMASession = () => {
  $('header .session').each(function () {
    const $session = $(this);
    const $userLinks = $session.find('.userLinks');
    const url = $session.data('url');
    if (!url || url.length === 0) {
      return
    }
    const orgHtml = $userLinks.html()
    let $iframe = null

    const load = () => {
      const loader = document.createElement('script');
      loader.type = 'text/javascript';
      loader.id = 'ma-session-loader';
      loader.onload = () => {
        $session.addClass('loaded loading-success');
      }
      loader.onerror = () => {
        $session.addClass('loaded loading-failed');
      }
      loader.src = url;
      document.head.appendChild(loader);
    }

    const unload = () => {
      $session.removeClass('loaded loading-success loading-failed');
      $('script#ma-session-loader').remove();
      $userLinks.removeClass('injected').html(orgHtml)
      window.removeEventListener('message', onMessage);
    }

    const onMessage = (e) => {
      if (!e.data || e.data.type !== 'ma_session') { return }

      console.debug('MA Session iframe message', e.data);
      if (e.data.height) {
        resizeIframe(e.data.height);
      }
      switch(e.data.action) {
        case 'keep':
          keepMenuOpen();
          break;
        case 'close':
          setTimeout(() => {
            reload();
          }, e.data.wait || 1);
          break;
        case 'off':
          unload();
          break;
      }
    }

    const initIframe = () => {
      $iframe = $session.find('iframe.ma')
      if ($iframe.length === 0) {
        console.error("cannot find ma session iframe")
        return;
      }
      window.addEventListener('message', onMessage);
    }

    const keepMenuOpen = () => {
      $session.find('input#avatar_menu_toggle:checkbox').prop('checked', true);
    }

    // close menu when clicking outside
    $(document).on("click", function (e) {
      if (
        !$(e.target).closest("header .session").length
      ) {
        $session.find('input#avatar_menu_toggle:checkbox:checked').prop('checked', false);
      }
    });


    const reload = () => {
      console.debug('Reloading session');
      unload();
      load();
    }

    const resizeIframe = (height) => {
      if ($iframe.length === 0) {
        return;
      }
      $iframe.css('height', `${height + 20}px`).addClass('loaded');
    }

    $session.on('ma:session:loaded', initIframe)
    load();
  });
}

export default loadMASession;
